var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('AppFooter',{staticClass:"p-2",staticStyle:{"position":"fixed","bottom":"0%","width":"100%"}}),_c('responsive-alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }